import { Newsletter } from 'cwp-components/popups'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { FloatingSubmenu } from './FloatingSubMenu'
import { MainNavItem } from './MainNavItem'
import { MenuColumn } from './MenuColumn'
import { Menu } from '../menuTypes'
import { useHoverMenuContext } from './HoverMenuContext'
import { brands } from 'assets/brands'

type HeaderMenuProps = {
  children?: React.ReactNode
  menu: Menu
  isPodcastRoute: boolean
}

export default function HeaderMenu({
  children,
  menu,
  isPodcastRoute = false,
}: HeaderMenuProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    menuRef,
    open,
    handleEnter,
    handleLeave,
    hoverMenuProps,
    floatingSubmenuProps,
    showFloatingSubmenu,
  } = useHoverMenuContext()

  return (
    <div
      ref={menuRef}
      className={`h-25 relative w-full flex 2xl:gap-6 xl:gap-4 sm:gap-1 items-center z-50 shadow-md ${
        isPodcastRoute ? '!bg-[#9ABDEC]' : 'bg-white'
      }`}
      {...hoverMenuProps}
    >
      <Link
        className={`flex items-center ml-6  ${
          isPodcastRoute ? '!bg-[#9ABDEC]' : 'bg-white'
        }`}
        to='/'
      >
        <img className='h-[32px] mr-4' src={brands.logo} alt='LU Logo' />
        <img
          className='h-[21px] mr-4 hidden xl:block 2xl:hidden'
          src={brands.wordmark}
          alt='LU wordmark'
        />
      </Link>

      <ul className='hidden lg:flex 2xl:space-x-8 xl:space-x-6 lg:space-x-4 space-x-2 relative'>
        {menu.map((item) => {
          const hasSubmenu = !!item.subs?.length
          return (
            <MainNavItem
              key={item.name}
              item={item}
              onEnter={() => handleEnter(item.name, hasSubmenu)}
              onLeave={handleLeave}
            />
          )
        })}
      </ul>

      {menu.map((item) => {
        const hasSubmenu = !!item.subs?.length
        return (
          hasSubmenu &&
          open === item.name && (
            <div
              key={item.name}
              className='hidden lg:grid absolute left-0 top-full w-screen bg-white pl-10 pr-10 pt-5 pb-5 grid-cols-3 z-40 shadow-inset-top-f4'
              onMouseEnter={() => handleEnter(item.name, hasSubmenu)}
              onMouseLeave={handleLeave}
            >
              {item.subs!.map((col, i) => (
                <MenuColumn
                  key={i}
                  rows={col}
                  setIsModalOpen={setIsModalOpen}
                />
              ))}
            </div>
          )
        )
      })}

      {children}

      {showFloatingSubmenu && <FloatingSubmenu {...floatingSubmenuProps} />}

      <Newsletter open={isModalOpen} closeModal={() => setIsModalOpen(false)} />
    </div>
  )
}
